<template>
  <el-header>
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      :ellipsis="false"
    >
      <el-menu-item index="0">
        <img height="24" src="@/assets/logo3.png" style="margin-top: 18px;"/>
      </el-menu-item>
      <div class="flex-grow" />
      <el-menu-item index="1">{{ username }}</el-menu-item>
      <el-menu-item index="2" @click="showpwsbox">修改密码</el-menu-item>
      <el-menu-item index="3" @click="loginout">退出</el-menu-item>
    </el-menu>
  </el-header>
  <el-dialog v-model="ispwsbox" title="修改密码">
    <el-form :model="form" label-width="120px">
      <el-form-item label="新密码">
        <el-input
          v-model="form.password"
          type="password"
          placeholder=""
          show-password
        />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
          v-model="form.repassword"
          type="password"
          placeholder=""
          show-password
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="ispwsbox = false">取消</el-button>
        <el-button type="primary" @click="changepwd">
          确认
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
  import { ref, reactive, getCurrentInstance } from 'vue'
  import {useRouter} from 'vue-router'
  import { useAlone } from '@/store';
  import pinia from '@/store/store';
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  const router = useRouter()
  const form = reactive({
    repassword:'',
    password:'',
  });
  const alone = useAlone(pinia)

  const username = localStorage.getItem('username')
  const ispwsbox = ref(false)
  const showpwsbox  = () => {
    ispwsbox.value = true
  }
  const changepwd  = () => {
    if(form.repassword != form.password){
      ElMessage.error('新密码与确认密码不一致')
      return
    }
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.changepwd(form).then((response:any) => {
      loading.close()
      if(response.code == 200){
        ElMessage({
          message: response.message,
          type: 'success',
        })
        ispwsbox.value = false
      } else if (response.code == 1002) {
        // 当前已经登录
        router.push({path: '/'})
      }else{
        ElMessage.error(response.message)
      }
    }).catch((response:any) => {
        ElMessage.error(response.message);
    })
  }
  const loginout  = () => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.loginout({}).then((response:any) => {
      loading.close()
      if(response.code == 200){
        localStorage.setItem('userId', '')
        localStorage.setItem('username', '')
        localStorage.setItem('token', '')
        ElMessage({
          message: response.message,
          type: 'success',
        })
        localStorage.setItem('userId', '')
        localStorage.setItem('username', '')
        alone.setLoginStatus(false)
        localStorage.setItem('sessionId','')
        router.push({path: '/login'})
      } else if (response.code == 1002) {
        // 当前已经登录
        router.push({path: '/'})
      }else{
        ElMessage.error(response.message)
      }
    }).catch((response:any) => {
        ElMessage.error(response.message);
    })
  }
</script>

<style lang="less">
.flex-grow {
  flex-grow: 1;
}
</style>
